import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import ServiceIntro from '../../components/ServiceIntro/ServiceIntro';
import productsData from '../../data/products.json';
import PurpleButton from '../../components/common/PurpleButton/PurpleButton';

import './ProductDetail.css';

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);

  const productContent = {
    title: product?.name || "",
    subtitle: product?.shortDesc || "",
    description: product?.features || [],
    image: product?.image || ""
  };

  useEffect(() => {
    // 搜索所有产品类别
    const findProduct = () => {
      // 获取products.json中的所有数组
      const allProductArrays = Object.values(productsData);
      
      // 在每个数组中查找产品
      for (const productArray of allProductArrays) {
        if (Array.isArray(productArray)) {
          const found = productArray.find(p => p.id === id);
          if (found) return found;
        }
      }
      return null;
    };

    const foundProduct = findProduct();
    setProduct(foundProduct);
  }, [id]);

  const handleQuoteClick = () => {
    navigate('/contact'); // 导航到联系页面
  };

  if (!product) {
    return <div>Loading...</div>;
  }

  return (
    <div className="product-detail-page flex flex-col min-h-screen">
      <Navbar />
      <ServiceIntro {...productContent} imageObjectFit="contain"/>
      
      <div className="quote-section container">
        <div className="quote-button-container">
          <PurpleButton 
            text="立即获得报价" 
            onClick={handleQuoteClick}
          />
        </div>
      </div>

      {/* <div className="product-detail-content container">
        <div className="features-section">
          <h2>功能与特色</h2>
          <ul className="features-list">
            {product.features.map((feature, index) => (
              <li key={index} className="feature-item">
                {feature}
              </li>
            ))}
          </ul>
        </div>
      </div> */}
      <div className='mt-auto'  style={{backgroundColor: '#f8f9fa'}}>
        <div className='container'>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default ProductDetail; 